module.exports = __webpack_public_path__ + "static/media/redd.9fd963e3.m4a";